import React, { Component } from "react";
import Table from "../../../../components/UI/Table/Table";
import "./Table.css";
import { DATE_FORMAT } from "../../../../constants";
import moment from "moment";
import { Link } from "react-router-dom";
import { TABLE_COLUMNS } from "./constant";
import { DEFAULT_PAGE_SIZE } from "../constants";

import CrawlerStart from "../../CommonComponent/CrawlerStart/index";

class TableView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.tasks,
      sorted: {
        id: "dueDate",
        desc: true,
      },
      body: null,
      showModal: false,
      dataAutomationData: {},
      pageSize: DEFAULT_PAGE_SIZE,
      currentPageIndex: 0,
    };
    
  }

  tableColumns = [
    {
      Header: "Case Name",
      id: "counterpartyName",
      accessor: d => (
        <Link
          id={d.caseId}
          to={`/case/view/${d.caseId}`}
          title={d.caseId}
          className={d.status === "REOPENED" ? "text-danger" : ""}
        >
          {d.counterpartyName}
        </Link>
      ),
    },
    {
      Header: "Corporate Name",
      id: "corporateName",
      accessor: d => <div title={d.corporateName}>{d.corporateName}</div>,
    },
    {
      Header: "Product Name",
      id: "productName",
      accessor: d => <div className="productName-cell" title={d.productName}>{d.productName}</div>,
    },
    {
      Header: 'Counterparty Type',
      id: "counterpartyType",
      accessor: d => <div title={d.counterpartyType}>{d.counterpartyType}</div>
    },
    {
      Header: "Identifiers",
      id: "identifiers",
      accessor: p => (
        <div title={p.gstNo ? p.gstNo : p.cinNumber ? p.cinNumber : p.panNo}>
          {p.panNo ? "PAN : " + p.panNo : null}
          {p.gstNo && p.panNo ? <br /> : null }
          {p.gstNo ? "GST : " + p.gstNo : null}
          {p.cinNumber && (p.panNo || p.gstNo)? <br /> : null}
          {p.cinNumber ? "CIN : " + p.cinNumber : null}
        </div>
      ),
      width: 250
    },
    {
      Header: "Created On",
      id: "createdAt",
      accessor: p => (
        <div title={moment(p.createdAt).format(DATE_FORMAT)}>
          {moment(p.createdAt).format(DATE_FORMAT)}
        </div>
      ),
      width: 120,
    },
    {
      Header: "Updated On",
      id: "updatedAt",
      accessor: p => (
        <div title={moment(p.updatedAt).format(DATE_FORMAT)}>
          {moment(p.updatedAt).format(DATE_FORMAT)}
        </div>
      ),
      width: 120,
    },
    {
      Header: h => (
        <div>
          <div>Crawl</div>
          <button className="btn btn-sm btn-info" onClick={this.getCrawlerStatus}>
            <i className="fa fa-refresh"></i>
          </button>
        </div>
      ),
      id: 'crawlers',
      className: 'center',
      Cell: ({ row }) => (
        <CrawlerStart 
          handleCrawlers={this.handleCrawlers} 
          data={row._original} 
        />
      ),
      width: 80,
      disableSortBy: true,
      defaultCanSort: false,
      sortable: false,
    }
  ];

  componentDidUpdate(prevProps) {
    if (this.props.tasks !== prevProps.tasks) {
      this.setState({
        data: this.props.tasks,
      });
    }
  }

  handleCrawlers = (selectedRowData, flag) => {
    this.props.crawlersInitiateCallback(selectedRowData, flag);
  };

  getCrawlerStatus = () => {
    if(this.props.getCrawlerStatus && typeof this.props.getCrawlerStatus === 'function') {
      console.log(this.props);
      this.props.getCrawlerStatus();
    }
  }

  render() {
    return (
      <div>
        <Table
          data={
            this.state.data.caseViewList ? this.state.data.caseViewList : []
          }
          columns={
            this.props.status === "PENDING" ? this.tableColumns : TABLE_COLUMNS
          }
          defaultSorted={[
            {
              id: "dueDate",
              desc: true,
            },
          ]}
          className="PendingCasesTable"
          noDataText="No cases found"
          multiSort={false}
          pages={this.state.data.numberOfPages}
          defaultPageSize={DEFAULT_PAGE_SIZE}
          showPagination={true}
          showPaginationTop={false}
          showPaginationBottom={true}
          manual // this would indicate that server side pagination has been enabled
          loading={this.props.loading}
          onPageChange={pageIndex => {
            // Called when the page index is changed by the user
            this.setState({
              currentPageIndex: pageIndex,
            });
            this.props.onFetchPage(
              this.props.status,
              pageIndex,
              this.state.pageSize,
              this.state.sorted,
            );
          }}
          onSortedChange={(newSorted, column, shiftKey) => {
            // Called when a sortable column header is clicked with the column itself and if the shiftkey was held. If the column is a pivoted column, 'column' will be an array of columns
            this.setState({
              sorted: newSorted[0],
            });
            this.props.onFetchPage(
              this.props.status,
              0,
              this.state.pageSize,
              newSorted[0],
            );
          }}
          onPageSizeChange={(pageSize, pageIndex) => {
            this.setState({
              pageSize: pageSize,
            });
            this.props.onFetchPage(
              this.props.status,
              0,
              pageSize,
              this.state.sorted,
            );
          }}
        />
      </div>
    );
  }
}

export default TableView;
